import React, { SVGProps } from 'react';

const BookMarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.814 1.83337C16.2982 1.83337 18.3057 2.81421 18.3332 5.30754V19.2225C18.3332 19.3784 18.2965 19.5342 18.2232 19.6717C18.104 19.8917 17.9023 20.0567 17.6548 20.13C17.4165 20.2034 17.1507 20.1667 16.9307 20.0384L10.9907 17.0684L5.0415 20.0384C4.90492 20.1108 4.74817 20.1575 4.59234 20.1575C4.079 20.1575 3.6665 19.7359 3.6665 19.2225V5.30754C3.6665 2.81421 5.68317 1.83337 8.15817 1.83337H13.814ZM14.4373 7.37004H7.53484C7.14067 7.37004 6.81984 7.69087 6.81984 8.09421C6.81984 8.49662 7.14067 8.81837 7.53484 8.81837H14.4373C14.8315 8.81837 15.1523 8.49662 15.1523 8.09421C15.1523 7.69087 14.8315 7.37004 14.4373 7.37004Z"
      //   fill="#ED9B74"
      fill="currentColor"
    />
  </svg>
);

export default BookMarkIcon;
